import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MaterialModule } from './material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SaveEditionsComponent } from './components/save-editions/save-editions.component';
import { FormDebugComponent } from './components/form-debug/form-debug.component';
import { DisableControlDirective } from './directives/disable-control/disable-control.directive';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatPaginatorIntl } from '@angular/material';
import { getDutchPaginatorIntl } from './components/crud/translate-paginator-intl';
import { ButtonLoaderDirective } from './directives/button-loader/button-loader.directive';
import { DisplayCrudDirective } from './directives/display-crud/display-crud.directive';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ModificationAlertDirective } from './directives/modification-alert/modification-alert.directive';
import { ModificationAlertComponent } from './directives/modification-alert/modification-alert.component';
import { ModificationFormAlertDirective } from './directives/modification-alert/modification-form-alert.directive';
import { ModificationFormLoadAlertDirective } from './directives/modification-alert/modification-form-load-alert.directive';
import { TypeofPipe } from './pipe/typeof.pipe';
import { NotificationComponent } from './components/notification/notification.component';
import { FormioModule, FormioAppConfig } from 'angular-formio';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { EditFormFieldComponent } from './components/edit-form-fields/edit-form-field.component';
import { EditFormLogicComponent } from './components/edit-form-logic/edit-form-logic.component';
import { EditFormDataComponent } from './components/edit-form-data/edit-form-data.component';
import { EditFormAdvancedComponent } from './components/edit-form-advanced/edit-form-advanced.component';
import { EditFormViewerComponent } from './components/edit-form-viewer/edit-form-viewer.component';
import { EditFormIdentityComponent } from './components/edit-form-identity/edit-form-identity.component';
import { AppConfig } from '@configApp/formio-config';
import { CovalentCodeEditorModule } from '@covalent/code-editor';
import { PsTemplates } from 'src/app/formio-templates/psTemplates';
import { TotvsQueryFieldsComponent } from './components/totvs-query-fields/totvs-query-fields.component';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { ColorPaletteGeneratorModule } from 'rubeus-components';
import { UpdatePaginationMatTabDirective } from './directives/update-pagination-mat-tab/update-pagination-mat-tab.directive';
import { EditFormRelationComponent } from './components/edit-form-relation/edit-form-relation.component';
import { ModificationMutipleAlertDirective } from './directives/modification-alert/modification-mutiple-alert.directive';
import { ToNumberPipe } from './pipe/toNumber.pipe';
import { RemoveValueQueryPipe } from './pipe/removeValueQuery.pipe';
import { FormRenderComponent } from 'src/app/modules/client/form-render/form-render.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { AddsPareamentsComponent } from './components/adds-pareaments/adds-pareaments.component';
import { replaceVariables } from './components/replace-variables/replace-variables.component';
import { AddsPareamentsSecondaryComponent } from './components/adds-pareaments-secondary/adds-pareaments-secondary.component';
import { SimplebarAngularModule } from 'simplebar-angular';
import { registryUploadComponent } from './components/upload/upload-type';
import { registryCustoSelectFieldTypeComponent } from './components/custom-select/custom-select-type';
import { registryCustomSelectBoxesFieldTypeComponent } from './components/custom-selectboxes/custom-selectboxes.component';
import { FieldsRelatedToButtonIntegrationComponent } from './components/fields-related-to-button-integration/fields-related-to-button-integration.component';
import { AutocompleteSystemFieldsComponent } from './components/autocomplete-system-fields/autocomplete-system-fields.component';
import { EditFormMultivalueComponent } from './components/edit-form-multivalue/edit-form-multivalue.component';
import { NativeDateAdapter, SatNativeDateModule } from 'saturn-datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, SatDatepickerModule } from 'saturn-datepicker';
import { Platform } from '@angular/cdk/platform';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { TextareaWithEditorComponent } from './components/textarea-with-editor/textarea-with-editor.component';
import { LgpdSignaturesComponent } from './components/lgpd-signatures/lgpd-signatures.component';
import { registryLgpdComponent } from './components/lgpd/lgpd';
import { FieldsRelatedToButtonEduConnectPayIntegrationComponent } from './components/fields-related-to-button-eduConnect-pay-integration/fields-related-to-button-eduConnect-pay-integration.component';
import { FieldsRelatedToButtonTotvsInstantPaymentIntegrationComponent } from './components/fields-related-to-button-totvs-instant-payment-integration/fields-related-to-button-totvs-instant-payment-integration.component';
import { LogFileDownloadComponent } from './components/log-file-download-card/log-file-download.component';
import { TypePipe } from './pipe/type.pipe';
import { PropertyFieldValuePipe } from './pipe/property-field-value.pipe';
import { JsonBuilderComponent } from './components/json-builder/json-builder.component';
import { TemplateArrayComponent } from './components/json-builder/templates-json/template-array/template-array.component';
import { TemplateObjectComponent } from './components/json-builder/templates-json/template-object/template-object.component';
import { TemplateButtonAddAttribute } from './components/json-builder/templates-json/template-button-add-attribute/template-button-add-attribute.component';
import { TemplatePropertyComponent } from './components/json-builder/templates-json/template-property/template-property.component';
import { InitialPageComponent } from './components/initial-page/initial-page.component';
import { FormioFunctions } from '@app/model/formio-functions.model';
import { LoginFieldsComponent } from './components/login-fields/login-fields.component';
import { ParameterIconDisableDirective } from './directives/parameter-icon-disable/parameter-icon-disable.directive';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;
export const MY_FORMATS = {
  parse: {
    dateInput: {day: '2-digit', month: '2-digit', year: 'numeric'},
  },
  display: {
    dateInput: 'input',
    monthYearLabel: {year: 'numeric', month: 'numeric'},
    dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
    monthYearA11yLabel: {year: 'numeric', month: 'long'},
  },
};
export class AppDateAdapter extends NativeDateAdapter {
  parse(value: string): Date | null  {
    if ((typeof value === 'string') && (value.indexOf('/') > -1)) {
      const str = value.split('/');
      const year = Number(str[2]);
      const month = Number(str[1]) - 1;
      const date = Number(str[0]);
      return new Date(year, month, date);
    }
    const timestamp = typeof value === 'number' ? value : Date.parse(value);
    return isNaN(timestamp) ? null : new Date(timestamp);
  }

  format(date: Date, displayFormat: string): string {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    if (displayFormat === 'input') {
      return `${day.toString().length === 1 ? '0' + day : day}/${month.toString().length === 1 ? '0' + month : month}/${year}`;
    }
    return (month.toString().length === 1 ? '0' + month : month) + '/' + date.getFullYear();
  }
}

@NgModule({
  declarations: [
    InitialPageComponent,
    SaveEditionsComponent,
    FormDebugComponent,
    NotificationComponent,
    ModificationFormAlertDirective,
    ModificationAlertComponent,
    ButtonLoaderDirective,
    DisableControlDirective,
    DisplayCrudDirective,
    ModificationAlertDirective,
    ModificationFormLoadAlertDirective,
    ModificationMutipleAlertDirective,
    UpdatePaginationMatTabDirective,
    ParameterIconDisableDirective,
    TypeofPipe,
    ToNumberPipe,
    RemoveValueQueryPipe,
    EditFormFieldComponent,
    EditFormLogicComponent,
    EditFormDataComponent,
    EditFormAdvancedComponent,
    EditFormViewerComponent,
    EditFormRelationComponent,
    TotvsQueryFieldsComponent,
    EditFormIdentityComponent,
    EditFormMultivalueComponent,
    FormRenderComponent,
    BreadcrumbComponent,
    AddsPareamentsComponent,
    AddsPareamentsSecondaryComponent,
    FieldsRelatedToButtonIntegrationComponent,
    FieldsRelatedToButtonEduConnectPayIntegrationComponent,
    FieldsRelatedToButtonTotvsInstantPaymentIntegrationComponent,
    AutocompleteSystemFieldsComponent,
    replaceVariables,
    TextareaWithEditorComponent,
    LgpdSignaturesComponent,
    LogFileDownloadComponent,
    TypePipe,
    PropertyFieldValuePipe,
    JsonBuilderComponent,
    TemplateArrayComponent,
    TemplateObjectComponent,
    TemplatePropertyComponent,
    TemplateButtonAddAttribute,
    LoginFieldsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    OverlayModule,
    MaterialModule,
    FlexLayoutModule,
    CovalentCodeEditorModule,
    CKEditorModule,
    FormioModule,
    ColorPaletteGeneratorModule,
    SimplebarAngularModule,
    NgxMaskModule.forRoot(options),
    SatDatepickerModule,
    SatNativeDateModule,
    EditorModule
  ],
  exports: [
    InitialPageComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule,
    FlexLayoutModule,
    DragDropModule,
    SimplebarAngularModule,
    SaveEditionsComponent,
    FormDebugComponent,
    NotificationComponent,
    ModificationAlertComponent,
    ModificationFormAlertDirective,
    DisableControlDirective,
    ButtonLoaderDirective,
    DisplayCrudDirective,
    ModificationAlertDirective,
    ModificationFormLoadAlertDirective,
    ModificationMutipleAlertDirective,
    UpdatePaginationMatTabDirective,
    ParameterIconDisableDirective,
    EditFormFieldComponent,
    EditFormLogicComponent,
    EditFormDataComponent,
    EditFormAdvancedComponent,
    EditFormViewerComponent,
    EditFormRelationComponent,
    CovalentCodeEditorModule,
    CKEditorModule,
    FormioModule,
    TypeofPipe,
    ToNumberPipe,
    RemoveValueQueryPipe,
    TotvsQueryFieldsComponent,
    OverlayModule,
    ColorPaletteGeneratorModule,
    NgxMaskModule,
    EditFormIdentityComponent,
    EditFormMultivalueComponent,
    FormRenderComponent,
    BreadcrumbComponent,
    AddsPareamentsComponent,
    AddsPareamentsSecondaryComponent,
    FieldsRelatedToButtonIntegrationComponent,
    FieldsRelatedToButtonEduConnectPayIntegrationComponent,
    FieldsRelatedToButtonTotvsInstantPaymentIntegrationComponent,
    AutocompleteSystemFieldsComponent,
    replaceVariables,
    SatDatepickerModule,
    SatNativeDateModule,
    EditorModule,
    TextareaWithEditorComponent,
    LgpdSignaturesComponent,
    LogFileDownloadComponent,
    TypePipe,
    PropertyFieldValuePipe,
    JsonBuilderComponent,
    TemplateArrayComponent,
    TemplateObjectComponent,
    TemplatePropertyComponent,
    TemplateButtonAddAttribute,
    LoginFieldsComponent
  ],
  providers: [
    FormioFunctions,
    { provide: MatPaginatorIntl, useValue: getDutchPaginatorIntl() },
    { provide: FormioAppConfig, useValue: AppConfig },
    { provide: DateAdapter, useClass: AppDateAdapter, deps: [MAT_DATE_LOCALE, Platform]},
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR'},
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' }
  ],
})
export class SharedModule {
  constructor() {
    registryUploadComponent();
    registryCustoSelectFieldTypeComponent();
    registryCustomSelectBoxesFieldTypeComponent();
    registryLgpdComponent();
    // seta as templates de componentes do formio
    const templates = new PsTemplates();
    // const formioConfig = new FormioConfig();
    // formioConfig.widgetDefaults();
    templates.setComponents();
    templates.setTemplates();
  }

}
